module.exports = __webpack_public_path__ + "static/media/joy_110.32cbcf79.ico";